import type { RouteRecordRaw } from 'vue-router'

import { routeEmployeesHome, routeEmployeesRoot } from './employeeRoutes'

const routeHRHome: RouteRecordRaw = {
  name: 'hr-home',
  path: '',
  redirect: routeEmployeesHome,
}

const routeHRRoot: RouteRecordRaw = {
  children: [routeHRHome, routeEmployeesRoot],

  path: 'hr',
}

export { routeHRRoot }
